import {
  Toast
} from 'vant'

Toast.setDefaultOptions({
  mask: true,
  className: 'i-toast',
  closeOnClick: true,
});

function toast(type, options) {
  if (type == 'text') {
    options = Object.assign(options, {
      closeOnClick: false,
    });
    return Toast(options);
  }
  return Toast[type](options);
}

function showLoading(text = '正在加载') {
  return toast('loading', {
    message: text,
    duration: 0,
  });
}

function success(text, d = 2500, fn) {
  return toast('success', {
    message: text,
    duration: d,
    icon: 'passed',
    onClose: fn
  });
}

function fail(text, d = 2500, fn) {
  return toast('fail', {
    message: text,
    duration: d,
    icon: 'close',
    onClose: fn
  });
}

function warn(text, d = 2500, fn) {
  return toast('fail', {
    message: text,
    duration: d,
    icon: 'warning-o',
    onClose: fn
  });
}

function text(text, position = 'middle') {
  return toast('text', {
    message: text,
    position: position,
    duration: 2500,
    mask: false,
    className: ''
  });
}

function clear(id) {
  Toast.clear(id)
}

function hideLoading() {
  setTimeout(() => {
    clear();
  }, 300);
}

export default {
  showLoading,
  hideLoading,
  success,
  fail,
  warn,
  text,
  clear
}